import slugify from "@sindresorhus/slugify";
import clsx from "clsx";

import { ICommentDTO } from "types";
export { clsx as cx, slugify };

export function calculateTotalCommentsSize(comments: ICommentDTO[]): number {
    let totalSize = 0;
    for (const comment of comments) {
        totalSize += 1; // Count the current comment
        if (comment.replies && comment.replies.length > 0) {
            // Recursively count replies
            totalSize += calculateTotalCommentsSize(comment.replies);
        }
    }
    return totalSize;
}

// lib/loadScript.ts
export function loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
        // Check if the script is already loaded
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () =>
            reject(new Error(`Failed to load script ${src}`));
        document.body.appendChild(script);
    });
}
